import SettingsCard from './settings-card';

export default SettingsCard;
